<script lang="ts">
    import { untrack } from 'svelte';
    import { navigationLog } from '@shared/log.browser.ts';
    import type { PrimitiveLabels } from '@shared/tracking/TrackingLabels.ts';
    import type { HistoryCheckpoint } from '@shared/types/History.ts';
    import type { DresonRuleResolvedEvent, Page } from '@shared/types/Tilelist.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { appendHeurekaFragment, clean, pagedUrl } from './Utils.browser.ts';

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    interface Props {
        rule: string;
        page?: Page;
    }

    let { rule: initialRule, page }: Props = $props();

    const wiring = injectWiring(['eventsIncoming', 'eventsOutgoing', 'navigationHistory', 'trackingService']);
    const onex = wiring.onex;

    /**
 *
 *
 *
 *
 *
 *
 */
    function checkpointData(rule: string, page: Page, tsLink?: PrimitiveLabels) {
        return {
            rule: rule,
            /*                                                                           */
            page: { ...page },
            tsLink,
            historic: true,
        };
    }

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    function createCheckpoint(event: DresonRuleResolvedEvent) {
        const { rule, page, tsLink, historic, redirect } = event,
            cleanedPage = clean(page);

        const trackingUrl = redirect || pagedUrl(cleanedPage, window.location.pathname, window.location.search);

        /*                                                               */
        wiring.trackingService?.trackUrl(trackingUrl);

        if (historic) return;

        let url = trackingUrl;

        if (redirect && onex.isToggleActive('DA_KEEP_HEUREKA_SHEET_FRAGMENT')) {
            url = appendHeurekaFragment(url);
        }

        if (wiring.navigationHistoryEnabled) {
            wiring.navigationHistory.checkpoint(
                {
                    ...checkpointData(rule, page, tsLink),
                    entryRule: wiring.navigationHistory.currentEntryRule(initialRule),
                },
                url,
            );
        } else {
            const checkpoint = {
                topic: 'ftfind.dresonRule.resolve',
                data: checkpointData(rule, page, tsLink),
                url,
            };
            navigationLog.debug('Creating legacy QBus history checkpoint', checkpoint);
            wiring.eventsOutgoing.pushHistoryCheckpoint(checkpoint);
        }
    }

    function restoreCheckpoint(state: HistoryCheckpoint) {
        wiring.eventsOutgoing.requestPageResolution({ ...state, historic: true });
    }

    $effect(() => {
        const navigationHistoryEnabled = wiring.navigationHistoryEnabled;
        if (navigationHistoryEnabled === null || !wiring.eventsIncoming || !wiring.eventsOutgoing) return;

        /*                                                               */
        return untrack(() => {
            const eventsOutgoing = wiring.eventsOutgoing;
            const eventsIncoming = wiring.eventsIncoming;
            const navigationHistory = wiring.navigationHistory;

            if (!navigationHistoryEnabled) {
                /*                                                                            */
                const data = checkpointData(initialRule, page ?? {}, {});

                navigationLog.debug('Seeding legacy QBus history', data);
                eventsOutgoing.seedHistoryState({
                    topic: 'ftfind.dresonRule.resolve',
                    data,
                });
            }
            const unsubscribePageResolved = eventsIncoming.onPageResolved(createCheckpoint);
            const unsubscribeRestore = navigationHistoryEnabled
                ? navigationHistory.onRestore(restoreCheckpoint)
                : undefined;

            return () => {
                unsubscribePageResolved();
                unsubscribeRestore?.();
            };
        });
    });
</script>
